export default {
    computed: {
        translations() {
            return this.$store.state.slices.items?.['threat-catalog'] || {};
        },

        enabledLocales() {
            const toExclude = ['en-eu', 'en-gb', 'en-sg'];
            const languages = this.translations.common?.localeLanguageMapping || {};
            return (this.$store.state.locales.locales || [])
                .filter((locale) => locale.is_active_on_blog_tru && !toExclude.includes(locale.code))
                .map((locale) => ({
                    ...locale,
                    language: languages[locale.code],
                }));
        },
    },

    methods: {
        getBlogPostFields(post, translations) {
            if (!post) return null;

            const slug = post.slug
                .replace('threat-catalog-', '')
                .replace('malware-', 'malware/');

            return {
                ...post,
                minReadTitle: translations.minRead,
                link: `/tru/threat-catalog/${slug}/`,
            };
        },

        getAuthorFields(author) {
            if (!author) return null;

            const socials = [];
            if (author.link_linked_in) {
                socials.push({
                    to: author.link_linked_in,
                    glyph: 'linkedin2',
                });
            }
            if (author.link_twitter) {
                socials.push({
                    to: author.link_twitter,
                    glyph: 'twitter',
                });
            }
            if (author.link_website) {
                socials.push({
                    to: author.link_website,
                    glyph: 'language-select',
                });
            }

            return {
                ...author,
                socials,
                link: `/blog/authors/${author.slug}`,
            };
        },
    },
};
